export function LogoMark({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      data-testid="logo-mark"
    >
      <rect width="64" height="64" rx="16" fill="#0F172A" />
      <path
        d="M32 10c-9.4 0-17 7.4-17 16.6C15 38.5 32 54 32 54s17-15.5 17-27.4C49 17.4 41.4 10 32 10z"
        fill="#0D9488"
      />
      <path
        d="M23.5 27.5l6 6L42 21"
        stroke="#FFFFFF"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function Logo({ dark = false }) {
  return (
    <span className="flex items-center gap-2.5" data-testid="site-logo">
      <LogoMark size={38} />
      <span className="leading-tight">
        <span
          className={`block font-display text-lg font-bold tracking-tight ${
            dark ? "text-white" : "text-slate-900"
          }`}
        >
          SwiftTest
        </span>
        <span
          className={`block text-[10px] font-bold uppercase tracking-[0.22em] ${
            dark ? "text-teal-300" : "text-teal-700"
          }`}
        >
          Solutions LLC
        </span>
      </span>
    </span>
  );
}
